<template>
  <div id="app" :class="{ hasBar: showTitleBar, underWechat }">
    <title-bar-comp v-if="showTitleBar" class="global-title-bar" />

    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>

    <router-view v-if="!$route.meta || !$route.meta.keepAlive" />
  </div>
</template>

<script>
import { BrowserUtil } from 'kuaidong-lib'
import { systemStore } from 'kuaidong-store'
import TitleBarComp from './components/global/TitleBar.vue'

export default {
  components: {
    TitleBarComp,
  },

  data() {
    return {
      underWechat: false,
    }
  },

  computed: {
    showTitleBar() {
      return systemStore.titleBarVisible
    },
  },

  async mounted() {
    this.underWechat = BrowserUtil.isWechat()
  },
}
</script>

<style lang="less">
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
  margin: 0 auto;
  height: 100vh;
  width: 100vmin;
  text-align: center;

  &.hasBar {
    padding-top: 52px;
  }

  &.disable-scroll {
    overflow: hidden;
  }
}
</style>
